class mobileNavigation {

    constructor() {
        this.$container = $('#mobileNavigation');
        this.$openButton = $('#pageHeader__toggle');
        this.$closeButton = $('#mobileNavigation__toggle');
        this.$subs = this.$container.find('.hasSub > a');
        this.createOverlay(this.$container);
        this.events();
    }

    // open navigation
    open() {
        this.$container.addClass('isActive');
        this.$overlay.stop().fadeIn();
        hideSearch();
        hideShare();
    }

    // close navigation
    close() {
        let that = this;
        that.$container.removeClass('isActive');
        that.$overlay.stop().fadeOut();

        // hide sub navs on close nav
        setTimeout(function () {
            that.$subs.each(function () {
                $(this).parent()
                    .removeClass('isActive')
                    .children('ul').hide();
            });
        }, 250)
    }

    // open / close sub navigation and close others
    openSub($element) {
        let $parent = $element.parent();

        if ($parent.hasClass('isActive')) {
            $parent
                .removeClass('isActive')
                .children('ul').stop().slideUp();
        } else {
            $parent
                .addClass('isActive')
                .children('ul').stop().slideDown();
        }

        $parent.siblings().each(function () {
            $(this)
                .removeClass('isActive')
                .children('ul').stop().slideUp();
        });
    }

    // add nav overlay to page
    createOverlay($parent) {
        let $elm = $('<div>');
        $elm
            .addClass('mobileNavigation__overlay')
            .attr('id', 'mobileNavigation__overlay');

        $parent.parent().append($elm);
        this.$overlay = $elm;
    }

    // events
    events() {
        let that = this;

        that.$openButton.on('click', function () {
            that.open();
        });

        that.$closeButton.on('click', function () {
            that.close();
        });

        that.$overlay.on('click', function () {
            that.close();
        });

        that.$subs.on('click', function (e) {
            e.preventDefault();
            that.openSub($(this));
        });
    }
}

$(function () {
    new mobileNavigation();
});